module.exports = __webpack_public_path__ + "img/空白（居右页码+静态文字）.f25822c5.jpg";